import styled from 'styled-components';
import { StyledText } from '../../main/theme';

export const StyledTimeAgo = styled(StyledText)`
  color: ${({ theme }) => theme.colors.system.darkGrey};
`;
